import React from 'react';
import { Link } from 'react-router-dom';
import styles from './sellerData.module.css';
import { useLanguage } from '../../i18n/LanguageContext';

const SellerData = ({ data, onDelete }) => {
  const { t, languageMeta } = useLanguage();

  // Funktion för att formatera datum från API response
  const formatDateString = (item) => {
    const locale = languageMeta?.locale || 'en-US';
    if (!item.created_at) {
      // Fallback om created_at inte finns
      const today = new Date();
      return today.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
    
    // Använd det faktiska datumet från created_at
    const date = new Date(item.created_at);
    
    // Formatera datum på svenska med Stockholm timezone
    return date.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'Europe/Stockholm'
    });
  };

  return (
    <div className={styles.sellerDataContainer}>
      {data.length > 0 ? (
        <div className={styles.sellerDataList}>
          {data.map((item, index) => (
            <div key={index} className={styles.sellerDataItem}>
              <Link to={`/seller-data/${item.id}`} className={styles.sellerDataLink}>
                <div className={styles.sellerDataContent}>
                  <span className={styles.objectTitle}>{item.address}</span>
                  <span className={styles.objectDate}>{t('sellerData.created')} {formatDateString(item)}</span>
                  <span className={styles.objectStatus}>{t('sellerData.details')}</span>
                </div>
              </Link>
              <button 
                className={styles.deleteButton}
                onClick={() => onDelete(item.id)}
                aria-label={t('sellerData.deleteListing')}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>
          <p>{t('sellerData.empty')}</p>
          <p className={styles.emptyStateSubtext}>{t('sellerData.emptySubtext')}</p>
        </div>
      )}
    </div>
  );
};

export default SellerData;
